module.exports = __webpack_public_path__ + "img/broadband.001dceb.svg";